import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { FilterButton } from '../../../../../../../../common/react/components/FilterButton';

/**
 * @param {object} props - Props.
 * @returns {JSX.Element} Component.
 */
export const StatsSectionNav = props => {
    const [
        areFilterOptionsVisible,
        setAreFilterOptionsVisible
    ] = useState( false );

    
    const children = React.Children.toArray( props.children );
    
    if ( !children?.length ) {
        return <></>;
    }

    const NavItems = children.find( child => child.props.name === 'StatsSectionNavItems' );
    const FilterItems = children.find( child => child.props.name === 'StatsSectionNavFilterItems' );
    
    return (
        <div className="u-stats-shadow" style={{ marginBottom: '1.6rem' }}>
            <div className="stats-leaders-nav">
                { NavItems }
                { !!FilterItems && (
                    <div className="stats-leaders-nav__filter-button-wrapper">
                        <FilterButton onChange={ setAreFilterOptionsVisible } />
                    </div>
                ) }
            </div>
            { areFilterOptionsVisible && FilterItems }
        </div>
    );
};

StatsSectionNav.defaultProps = {
    name: 'StatsSectionNav'
};

StatsSectionNav.propTypes = {
    children: PropTypes.any.isRequired
};